import { useEffect, useMemo } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router';

const useShopifyRouteControl = ({ routes, hasShopify = false, redirectTo, enabled = true }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const filteredRoutes = useMemo(() => {
    if (!enabled || !routes) return [];

    return routes.filter(({ shopifyAvailable }) => {
      if (shopifyAvailable === 'always') return true;
      if (shopifyAvailable === 'on') return hasShopify;
      if (shopifyAvailable === 'off') return !hasShopify;
      return true;
    });
  }, [enabled, routes, hasShopify]);

  const currentRoute = useMemo(() => {
    if (!enabled || !routes) return null;

    return routes.find((route) => matchPath({ path: route.key, end: true }, pathname));
  }, [enabled, routes, pathname]);

  const shouldRedirect = useMemo(() => {
    if (!enabled || !currentRoute) return false;

    return !filteredRoutes.includes(currentRoute);
  }, [enabled, currentRoute, filteredRoutes]);

  useEffect(() => {
    if (shouldRedirect) {
      navigate(redirectTo, { replace: true });
    }
  }, [shouldRedirect, redirectTo, navigate]);

  return {
    filteredRoutes,
    shouldRedirect,
  };
};

export default useShopifyRouteControl;
